const MTR_FIELD_LABELS = {
  mtrKind: '物料類型',
  mtrStructMainId: '主分類',
  mtrStructSubId: '次分類',
  mtrTemplateId: '物料模板',
  manufacturerId: '製造商',
  baseUnitCode: '基本單位英文縮寫',
  baseUnitName: '基本單位名稱',
  unitConvert: '換算單位',
  mtrNo: '料號',
  name: '名稱',
  sortKey: '排序鍵',
  remark: '備註',
  safetyQty: '安全庫存',
  baseUnitPrice: '基礎單價',
  receiptDefaultQty: '入庫預設數量',
  defaultDisplayUnit: '預設顯示單位',
  originalSerialListText: '原廠料號',
  specEntries: '規格值',
  specCustom: '自訂規格',
  assemblyOptions: '替代子料',
  bomId: '關聯 BOM',
};

function resolveMtrFieldLabel(path) {
  const specOptionMatch = path.match(/^specEntries\.(\d+)\.mtrSpecOptionId$/);
  if (specOptionMatch) {
    return `規格選項 #${Number(specOptionMatch[1]) + 1}`;
  }

  const specInputMatch = path.match(/^specEntries\.(\d+)\.inputValue$/);
  if (specInputMatch) {
    return `規格輸入 #${Number(specInputMatch[1]) + 1}`;
  }

  const customKeyMatch = path.match(/^specCustom\.(\d+)\.customKey$/);
  if (customKeyMatch) {
    return `自訂規格鍵 #${Number(customKeyMatch[1]) + 1}`;
  }

  const customValueMatch = path.match(/^specCustom\.(\d+)\.inputValue$/);
  if (customValueMatch) {
    return `自訂規格值 #${Number(customValueMatch[1]) + 1}`;
  }

  const convertCodeMatch = path.match(/^unitConvert\.(\d+)\.code$/);
  if (convertCodeMatch) {
    return `換算單位 ${Number(convertCodeMatch[1]) + 1}. 英文縮寫`;
  }

  const convertNameMatch = path.match(/^unitConvert\.(\d+)\.name$/);
  if (convertNameMatch) {
    return `換算單位 ${Number(convertNameMatch[1]) + 1}. 名稱`;
  }

  const convertRateMatch = path.match(/^unitConvert\.(\d+)\.convertRate$/);
  if (convertRateMatch) {
    return `換算單位 ${Number(convertRateMatch[1]) + 1}. 換算`;
  }

  return undefined;
}

export {
  MTR_FIELD_LABELS,
  resolveMtrFieldLabel,
};
